export default __webpack_public_path__ + "static/media/safe-area.d19ee080.png";